import { mapGetters } from 'vuex'
import uniqid from 'uniqid'
import prefijos from '@/mixins/prefijos'

export default {
  mixins: [prefijos],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      getCompradores: 'compradores/getAll',
      getTipoDocumento: 'maestros/tiposDocumentos/getByIdBknd'
    }),
    estadosCiviles () {
      return [
        {
          value: 'casadoGanancial',
          text: this.$t('mixins.comprador.casadoGanciales')
        },
        {
          value: 'casadoSeparacion',
          text: this.$t('mixins.comprador.casadoSeparacion')
        },
        {
          value: 'soltero',
          text: this.$t('mixins.comprador.soltero')
        },
        {
          value: 'unionHecho',
          text: this.$t('mixins.comprador.unionHecho')
        },
        {
          value: 'divorciado',
          text: this.$t('mixins.comprador.divorciado')
        },
        {
          value: 'separado',
          text: this.$t('mixins.comprador.separado')
        },
        {
          value: 'viudo',
          text: this.$t('mixins.comprador.viudo')
        }
      ]
    },
    generos() {
      return [
        {
          value: 'H',
          text: this.$t('mixins.comprador.hombre')
        },
        {
          value: 'M',
          text: this.$t('mixins.comprador.mujer')
        }
      ]
    },
    origenesFondos () {
      return [
        {
          value: 'ahorros',
          text: this.$t('mixins.comprador.ahorros')
        },
        {
          value: 'donacion',
          text: this.$t('mixins.comprador.donacion')
        },
        {
          value: 'herencia',
          text: this.$t('mixins.comprador.herencia')
        },
        {
          value: 'hipoteca',
          text: this.$t('mixins.comprador.hipoteca')
        },
        {
          value: 'ventaInmueble',
          text: this.$t('mixins.comprador.ventaInmueble')
        },
        {
          value: 'otros',
          text: this.$t('mixins.comprador.otros')
        }
      ]
    },
    propositosContractuales () {
      return [
        {
          value: 'primeraVivienda',
          text: this.$t('mixins.comprador.primeraVivienda')
        },
        {
          value: 'segundaVivienda',
          text: this.$t('mixins.comprador.secundaVivienda')
        },
        {
          value: 'alquiler',
          text: this.$t('mixins.comprador.alquiler')
        },
        {
          value: 'actividadProfesional',
          text: this.$t('mixins.comprador.actividadProfesional')
        },
        {
          value: 'inversion',
          text: this.$t('mixins.comprador.inversion')
        },
        {
          value: 'otros',
          text: this.$t('mixins.comprador.otros')
        }
      ]
    },
    actividadesProfesionales () {
      return [
        {
          value: 'cuentaAjena',
          text: this.$t('mixins.comprador.cuentaAjena')
        },
        {
          value: 'cuentaPropia',
          text: this.$t('mixins.comprador.cuentaPropia')
        },
        {
          value: 'sinActividad',
          text: this.$t('mixins.comprador.sinActividad')
        }
      ]
    },
    actividadesNoProfesionales () {
      return [
        {
          value: 'jubilado',
          text: this.$t('mixins.comprador.jubilado')
        },
        {
          value: 'pensionista',
          text: this.$t('mixins.comprador.pensionista')
        },
        {
          value: 'rentista',
          text: this.$t('mixins.comprador.rentista')
        },
        {
          value: 'desempleado',
          text: this.$t('mixins.comprador.desempleado')
        },
        {
          value: 'laboresHogar',
          text: this.$t('mixins.comprador.laboresHogar')
        },
        {
          value: 'estudiante',
          text: this.$t('mixins.comprador.estudiante')
        }
      ]
    },
    naturalezaEntidades () {
      return [
        {
          value: 'cotizada',
          text: this.$t('mixins.comprador.cotizada')
        },
        {
          value: 'actividadComercial',
          text: this.$t('mixins.comprador.actividadComercial')
        },
        {
          value: 'sinActividadComercial',
          text: this.$t('mixins.comprador.sinActividadComercial')
        },
        {
          value: 'asociaciones',
          text: this.$t('mixins.comprador.asociaciones')
        }
      ]
    },
    ambitos () {
      return [
        {
          value: 'local',
          text: this.$t('mixins.comprador.local')
        },
        {
          value: 'nacional',
          text: this.$t('mixins.comprador.nacional')
        },
        {
          value: 'internacional',
          text: this.$t('mixins.comprador.internacional')
        }
      ]
    },
    getTitular () {
      return this.compradores.find(x => x.titular)
    },
    getRestoCompradores () {
      return this.compradores.filter(x => !x.titular)
    }
  },
  methods: {
    inicializarCompradores () {
      if (this.getCompradores.length === 0) { // Crear el comprador primero
        this.addComprador()
        this.compradores[0].titular = true
        this.compradores[0].juridico = false
        if (this.reserva.actor) {
          this.compradores[0].email = this.reserva.actor.email
          this.compradores[0].nombre = this.reserva.actor.nombre
          this.compradores[0].kyc.apellidos = this.reserva.actor.apellidos
          this.compradores[0].nif = this.reserva.actor.numdoc
          let tipoDocumentoObj = this.getTipoDocumento(this.reserva.actor.tipodoc)
          if (tipoDocumentoObj != null) {
            this.compradores[0].tipoDocumentoID = tipoDocumentoObj.COD_TIPO_DOCUMENTO_ID
          }
        }
      } else {
        // Crear copiad de comprador
        // Recorremos getCompradores y los pusheamos en compradores
        // No se puede hacer compradores = getCompradores.map() porque es una prop con .sync
        this.getCompradores.forEach(x => {
          
          let nuevo = this.nuevoComprador()
          let retorno = this.copiarCompradorFromStore(x)
          if (x.telefono != null) {
            let prefijo, numTelefono
              ({prefijo, numTelefono} = this.separarTelefono(x.telefono, x.codigoPrefijoTelefonicoId))
              retorno.codigoPrefijoTelefonicoId = prefijo
              retorno.numTelefono = numTelefono
          }
          if (retorno.kyc == null) {
            retorno.kyc = nuevo.kyc
          }
          if (retorno.kycJuridico == null) {
            retorno.kycJuridico = nuevo.kycJuridico
          }
          this.addComprador(retorno)
        })
      }
    },
    addComprador (comprador = null) {
      comprador = comprador != null ? comprador : this.nuevoComprador()
      if (this.compradores.length > 0) {
        if (this.expansion) {
          this.expansion.push(true)
        }
        
      }
      this.compradores.push(comprador)
    },
    nuevoComprador () {
      return {
        id_temporal: uniqid(),
        titular: false,
        juridico: false,
        relacionConTitular: null,
        nombre: null,
        tipoDocumentoID: null,
        nif: null,
        codigoNacionalidad: null,
        codigoTipoVia: null,
        domicilio: null,
        codigoPostal: null,
        poblacion: null,
        codigoProvincia: null,
        codigoPais: null,
        prefijo: null,
        numTelefono: null,
        telefono: null,
        email: null,
        porcentajeParticipacion: null,
        origenFondos: [],
        // codigoOrigenFondos: null,
        // origenFondosOtros: null,
        codigoPropositoContractual: null,
        titularCuenta: false,
        // propositoContractualOtros: null,
        cargoPublico: false,
        ingresos: [],
        gastos: [],
        kyc: {
          apellidos: null,
          codigoGenero: null,
          codigoPaisNacimiento: null,
          fechaNacimiento: null,
          ingresos: null,
          codigoEstadoCivil: null,
          actividadProfesional: null,
          codigoProfesion: null,
          ajenaNombreEmpresa: null,
          ajenaCargo: null,
          ajenaAntiguedadLaboral: null,
          propiaNombreSociedad: null,
          propiaPorcentajeSociedad: null,
          propiaVolumenSociedad: null,
          propiaAnoInicioSociedad: null,
          sinActividadMotivo: null,
          jubiladoCodigoProfesion: null,
          pensionistaConcepto: null,
          rentistaVolumen: null,
          cargoPublicoParentesco: null,
          cargoPublicoCargo: null,
          cargoPublicoCodigoPais: null,
          representante: false,
          representanteJuridico: null,
          representanteTipoDocumento: null,
          representanteDni: null,
          representanteCodigoGenero: null,
          representanteDenominacionSocial: null,
          representanteNombre: null,
          representanteApellido: null,
          representanteCodigoNacionalidad: null,
          representanteEscritura: null,
          representanteEscrituraFecha: null
        },
        kycJuridico: {
          titulares: [],
          apoderados: [],
          titularesNoCotizada: [],
          codigoActividadProfesional: null,
          volumen: null,
          fechaConstitucion: null,
          notarioConstitucion: null,
          poblacionConstitucion: null,
          cotizada: false,
          cargoPublicoDescripcion: null,
          naturaleza: null,
          ambito: null
        }
      }
    },
    nuevoTitularReal () {
      return {
        id_temporal: uniqid(),
        nombre: null,
        nif: null,
        codigoNacionalidad: null,
        codigoPais: null,
        porcentajeParticipacion: null
      }
    },
    nuevoApoderado () {
      return {
        id_temporal: uniqid(),
        nombre: null,
        nif: null,
        codigoNacionalidad: null,
        codigoPais: null,
        cargo: null
      }
    },
    nuevoTitularNoCotizada () {
      return {
        id_temporal: uniqid(),
        nombre: null,
        nif: null,
        codigoNacionalidad: null,
        codigoPais: null,
        porcentajeParticipacion: null
      }
    },
    autorellenarCompradorKyc (comprador) {
      let retorno = Object.assign(comprador, {
        nombre: comprador.nombre != null ? comprador.nombre : 'Marcos',
        tipoDocumentoID: 'P',
        nif: '12345678',
        codigoNacionalidad: '11',
        codigoTipoVia: 'CL',
        domicilio: 'Pradillo 12',
        codigoPostal: '28002',
        poblacion: 'Madrid',
        codigoProvincia: '28',
        codigoPais: '11',
        telefono: null,
        codigoPrefijoTelefonicoId: this.prefijos.find(x => x.codigo == '+34').id,
        numTelefono: '666666666',
        email: comprador.email != null ? comprador.email : 'cvicedo@overtek.com',
        porcentajeParticipacion: comprador.porcentajeParticipacion != null ? comprador.porcentajeParticipacion : '100',
        titularCuenta: true,
        origenFondos: ['1'],
        // codigoOrigenFondos: '5',
        // origenFondosOtros: null,
        codigoPropositoContractual: '5',
        // propositoContractualOtros: null,
        cargoPublico: true
      })
      retorno.kyc = Object.assign(comprador.kyc, {
        apellidos: comprador.kyc.apellidos != null ? comprador.kyc.apellidos : 'López',
        codigoGenero: 'H',
        codigoPaisNacimiento: '11',
        fechaNacimiento: '1995-06-04',
        ingresos: '12000',
        codigoEstadoCivil: 'W',
        actividadProfesional: 'cuentaAjena',
        codigoProfesion: '3820',
        ajenaNombreEmpresa: 'Overtek',
        ajenaCargo: 'Programador Web',
        ajenaAntiguedadLaboral: '5 meses',
        propiaNombreSociedad: null,
        propiaPorcentajeSociedad: null,
        propiaVolumenSociedad: null,
        propiaAnoInicioSociedad: null,
        sinActividadMotivo: null,
        jubiladoCodigoProfesion: null,
        pensionistaConcepto: null,
        rentistaVolumen: null,
        cargoPublicoParentesco: 'Tio',
        cargoPublicoCargo: 'Cocinero',
        cargoPublicoCodigoPais: '330',
        representante: true,
        representanteJuridico: false,
        representanteTipoDocumento: 'C',
        representanteDni: '47461873Q',
        representanteCodigoGenero: null,
        representanteDenominacionSocial: null,
        representanteNombre: 'Maria Francisca',
        representanteApellido: 'Test',
        representanteCodigoNacionalidad: '330',
        representanteEscritura: '123123133412412',
        representanteEscrituraFecha: '2018-05-21'
      })
      return retorno
    },
    autorellenarCompradorKycJuridico (comprador) {
      let retorno = Object.assign(comprador, {
        nombre: comprador.nombre != null ? comprador.nombre : 'Marcos López',
        tipoDocumentoID: 'C',
        nif: 'B8567234',
        codigoNacionalidad: '4',
        codigoTipoVia: 'AP',
        domicilio: 'Marie Courie',
        codigoPostal: '28532',
        poblacion: 'Rivas',
        codigoProvincia: '33',
        codigoPais: '11',
        codigoPrefijoTelefonicoId: this.prefijos.find(x => x.codigo == '+34').id,
        numTelefono: '662276659',
        telefono: '916784562',
        email: comprador.email != null ? comprador.email : 'cvicedo@overtek.com',
        porcentajeParticipacion: comprador.porcentajeParticipacion != null ? comprador.porcentajeParticipacion : '50',
        titularCuenta: false,
        origenFondos: ['3'],
        // codigoOrigenFondos: '3',
        // origenFondosOtros: null,
        codigoPropositoContractual: '5',
        // propositoContractualOtros: null,
        cargoPublico: true
      })
      retorno.kycJuridico = Object.assign(comprador.kycJuridico, {
        titulares: [
          {nombre: 'Pepe', nif: '625362718', codigoNacionalidad: '4', codigoPais: '11', porcentajeParticipacion: '50'}
        ],
        apoderados: [
          {nombre: 'Fran', nif: '8jasjd2718', codigoNacionalidad: '4', codigoPais: '11', cargo: 'delegado'}
        ],
        titularesNoCotizada: [],
        codigoActividadProfesional: '5221',
        volumen: '10000',
        fechaConstitucion: '2016-07-23',
        notarioConstitucion: '2016-08-27',
        poblacionConstitucion: 'Vallecas',
        cotizada: false,
        cargoPublicoDescripcion: 'Carpintero',
        naturaleza: 'actividadComercial',
        ambito: 'nacional'
      })
    },
    copiarCompradorFromStore (x) {
      let retorno = {
        ...x,
        documentacion: x.documentacion.map(d => {
          return {...d}
        }),
        contratoKyc: {
          ...x.contratoKyc
        },
        origenFondos: x.origenFondos.map(o => o.codigoOrigenFondos)
      }
      if (x.kycJuridico != null) {
        retorno.kycJuridico = {...x.kycJuridico}
        retorno.kycJuridico.cotizada = retorno.kycJuridico.cotizada ? retorno.kycJuridico.cotizada : false
        retorno.kycJuridico.cargoPublico = retorno.kycJuridico.cargoPublico ? retorno.kycJuridico.cargoPublico : false
        retorno.kycJuridico.titulares = retorno.kycJuridico.titulares.map(x => {
          return {...x}
        })
        retorno.kycJuridico.apoderados = retorno.kycJuridico.apoderados.map(x => {
          return {...x}
        })
        retorno.kycJuridico.titularesNoCotizada = retorno.kycJuridico.titularesNoCotizada.map(x => {
          return {...x}
        })
      }
      if (x.kyc != null) {
        retorno.kyc = {...x.kyc}
        retorno.kyc.representante = retorno.kyc.representante ? retorno.kyc.representante : false
      }
      if (x.validacionDocumentacion != null) {
        retorno.validacionDocumentacion = {...x.validacionDocumentacion}
      }
      if (x.validacionKyc != null) {
        retorno.validacionKyc = {...x.validacionKyc}
      }
      return retorno
    },
    // Formatea los documentos de los compradores
    formatearCompradorParaApi (x) {
      let documentacionComprador = []
      x.documentacion.forEach(doc => {
        doc.documento.forEach(archivo => {
          documentacionComprador.push({
            ...archivo,
            carpetaId: doc.carpetaId,
            validado: doc.validado
          })
        })
      })
      return {
        ...x,
        documentacion: documentacionComprador
      }
    },
    compradorEstaValidado (comprador) {
      let hayValidacion = comprador.validacionKyc != null
      if (hayValidacion) {
        return comprador.validacionKyc.datosCompradorValidos && comprador.validacionKyc.datosRepresentanteValidos
      }
      return true
    },
    nombreComprador (comprador) {
      return comprador.nombre
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/comprador.js